import { render } from "./ExamPatientAddOffcanvas.vue?vue&type=template&id=cf12b8a6&scoped=true"
import script from "./ExamPatientAddOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamPatientAddOffcanvas.vue?vue&type=script&lang=js"

import "./ExamPatientAddOffcanvas.vue?vue&type=style&index=0&id=cf12b8a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf12b8a6"]])

export default __exports__